import React from 'react';
import { Settings } from 'lucide-react';
import { BackButton } from '../../components/common/BackButton';
import { GeneralSettings } from '../../components/admin/settings/GeneralSettings';
import { EmailSettings } from '../../components/admin/settings/EmailSettings';
import { SecuritySettings } from '../../components/admin/settings/SecuritySettings';
import { IntegrationSettings } from '../../components/admin/settings/IntegrationSettings';

export function AdminSettingsPage() {
  return (
    <div>
      <BackButton to="/admin" label="Back to Admin Dashboard" />
      
      <div className="flex items-center space-x-2 mb-8">
        <Settings className="h-6 w-6 text-accent-green" />
        <h1 className="text-2xl font-bold text-white">Platform Settings</h1>
      </div>

      <div className="space-y-6">
        <GeneralSettings />
        <EmailSettings />
        <SecuritySettings />
        <IntegrationSettings />
      </div>
    </div>
  );
}